/**
 * LocalStorage adapter for the anonymous ID. The pure UUID v4 logic
 * lives in lib/anonymous-id.ts; this thin wrapper handles the side
 * effect of persisting one per device.
 *
 * Stage D split this off so the lib code stays Edge-runtime portable
 * (no `crypto`/`localStorage` references). MVP wires it in here at
 * Stage I when the search island first needs an anon_id for /api/track.
 */

import { generateAnonId, isValidAnonId } from "../lib/anonymous-id";

const STORAGE_KEY = "justleave.anon_id";

export function getOrCreateAnonId(): string {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && isValidAnonId(stored)) return stored;
  } catch {
    // Private mode / disabled storage — fall through to a fresh ID
    // that won't persist; track will still work for this session.
  }

  const fresh = generateAnonId({ randomUUID: () => crypto.randomUUID() });
  try {
    localStorage.setItem(STORAGE_KEY, fresh);
  } catch {
    // ignore — see above
  }
  return fresh;
}
